import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';

import { STORAGE, TokenProvider } from './token.provider';
import {
  AO_AUTH_URL, BASE_URL, PAYMENT_GATEWAY_URL, REDIRECT_URL, RequestOptions,
  SSO_TOKEN_NAME
} from '~auth/providers/auth.provider';
import { Observable } from 'rxjs/Observable';
import { User } from '~auth/model';
import { CommonService } from '../../util/common.service';

interface AOResponse {
  access_token: string;
  expires_in: number;
  token_type: string;
}

interface WeirdTokenFormat {
  aud: string;
  sub: string;
  fname: string;
  lname: string;
  nbf: number;
  iss: string;
  scopes: string[];
  exp: number;
  iat: number;
  jti: string;
  email: string;
}

@Injectable()
export class DacTokenProvider extends TokenProvider {

  constructor( @Inject(STORAGE) storage: Storage, @Inject(SSO_TOKEN_NAME) tokenName: string, private http: HttpClient, @Inject(AO_AUTH_URL) protected AO_URL: string, @Inject(BASE_URL) protected baseUrl: string, @Inject(PAYMENT_GATEWAY_URL) protected paymentGatewayUrl: string, service: CommonService) {
    super(storage, tokenName, service);
  }

  signIn(username: string, password: string) {
    const headers = new HttpHeaders({ 'Authorization': 'Basic ' + btoa(username + ':' + password) });
    return this.requestToken({ headers: headers, withCredentials: true });
  }

  refresh(local?: boolean): Observable<User> {
    return local && this.isAuthenticated()
      ? Observable.of(this.populateUser(this.getToken()))
      : this.requestToken({ withCredentials: true });
  }

  requestToken(options?: RequestOptions) {
    console.log(this.AO_URL)
    return this.http.get<AOResponse>(`${this.AO_URL}/auth/token`, options)
      .switchMap((response) => {
        // debugger;
        const token = response && response.access_token;
        if (!token) return Observable.of(null);

        const user = this.populateUser(token);

        this.storage.setItem(this.tokenName, token);
        this.storage.setItem(this.tokenName + 'Profile', JSON.stringify(user));

        return Observable.of(user);
      })
      .catch(error => {
        throw Observable.throw(error);
      });
  }

  signOut() {
    this.clearToken();
    this.http.get(`${this.AO_URL}/j_spring_security_logout`, { withCredentials: true })
      .take(1)
      .subscribe();
    return Observable.of(true);
  }

  intercept(request: HttpRequest<any>): HttpRequest<any> {
    if (request.url.indexOf(this.baseUrl) === 0
      || request.url.indexOf(this.AO_URL) === 0
      || request.url.indexOf(this.paymentGatewayUrl) === 0) return super.intercept(request);
    return request;
  }

  private populateUser(token: WeirdTokenFormat): User;
  private populateUser(token: string): User;
  private populateUser(token: string | WeirdTokenFormat): User {
    if (!token) return null;

    const data = typeof token === 'string'
      ? this.decodeToken(token)
      : token as WeirdTokenFormat;

    return new User({
      firstName: data.fname,
      lastName: data.lname,
      scopes: data.scopes,
      email: data.email
    })
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/providers/dac-token.provider.ts